import { gql } from "@apollo/client";

export const GET_VM_DISK_INFO = gql`
  query GetVmDiskInfo($vmId: Int!) {
    getVmDiskInfoById(vmId: $vmId) {
      vmName
      workspaceName
      diskFreePercent
      diskFreeMB
      diskFreeGB
      diskLastUpdated
    }
  }
`;